import SearchSolidSVG from "@design-system/ui-icons/vanilla/SearchSolid"
import { createIcon } from "../createIcon"

export const SearchSolidIcon = createIcon(SearchSolidSVG)
